import { IAreaFactor } from '../../interfaces/iarea-factor';
import { Area } from '../area';
import { AssetTeam } from '../asset-team';
import { DurationFactorType } from '../duration-factor-type';

export class AreaFactorBase {
  AreaFactorId: number;
  AreaId: number;
  DurationFactorTypeId: number;
  AssetTeamId: number;
  Factor: number;
  Created: Date | null;
  CreatedBy: string | null;
  Updated: Date | null;
  UpdatedBy: string | null;

  Area?: Area;
  AssetTeam?: AssetTeam;
  DurationFactorType?: DurationFactorType;

  constructor(item?: IAreaFactor) {
    if (item) {

      this.AreaFactorId = item.AreaFactorId;
      this.AreaId = item.AreaId;
      this.DurationFactorTypeId = item.DurationFactorTypeId;
      this.AssetTeamId = item.AssetTeamId;
      this.Factor = item.Factor;
      this.Created = item.Created ? new Date(item.Created) : null;
      this.CreatedBy = item.CreatedBy;
      this.Updated = item.Updated ? new Date(item.Updated) : null;
      this.UpdatedBy = item.UpdatedBy;

      this.Area = new Area(item.Area);
      this.AssetTeam = new AssetTeam(item.AssetTeam);
      this.DurationFactorType = new DurationFactorType(item.DurationFactorType);
    }
  }
}